import React from 'react';
import { Section } from '../ui/Section';
import { ClipboardCheck, CalendarClock, FileText, FileCheck2, MessageSquareHeart, HeartPulse, Wallet, LayoutDashboard } from 'lucide-react';
export function ContentDetails() {
  const tomos = [{
    num: 'T1',
    title: 'Diagnóstico y Puesta a Punto',
    subtitle: 'La base bien organizada',
    Icon: ClipboardCheck
  }, {
    num: 'T2',
    title: 'Agenda y Adherencia',
    subtitle: 'Ningún paciente se pierde',
    Icon: CalendarClock
  }, {
    num: 'T3',
    title: 'Historia Clínica e Informes',
    subtitle: 'Listos en minutos',
    Icon: FileText
  }, {
    num: 'T4',
    title: 'Autorizaciones',
    subtitle: 'Sin perder ningún trámite',
    Icon: FileCheck2
  }, {
    num: 'T5',
    title: 'Comunicación de Diagnóstico',
    subtitle: 'Para las consultas difíciles',
    Icon: MessageSquareHeart
  }, {
    num: 'T6',
    title: 'Prevención de Burnout',
    subtitle: 'Detectalo a tiempo',
    Icon: HeartPulse
  }, {
    num: 'T7',
    title: 'Facturación y Finanzas',
    subtitle: 'Exclusivo Megapack',
    Icon: Wallet,
    highlight: true
  }, {
    num: 'T8',
    title: 'Tablero de Indicadores',
    subtitle: 'Exclusivo Megapack',
    Icon: LayoutDashboard,
    highlight: true
  }];
  return <Section className="bg-white" data-id="element-61">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-62">
        <div className="text-center mb-8 md:mb-12" data-id="element-63">
          <h2 className="text-xs md:text-sm font-bold text-teal-600 tracking-widest uppercase mb-1 md:mb-2" data-id="element-64">
            Contenido Completo
          </h2>
          <h3 className="text-2xl md:text-4xl font-bold text-slate-900 mb-2 md:mb-4" data-id="element-65">
            LOS 8 TOMOS
          </h3>
          <p className="text-lg md:text-xl text-slate-600" data-id="element-66">
            Tu sistema completo para gestionar tu consultorio
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4" data-id="element-67">
          {tomos.map((tomo, i) => {
          const Icon = tomo.Icon;
          return <div key={i} className={`relative flex flex-col rounded-2xl border p-4 md:p-5 transition-all hover:-translate-y-1 hover:shadow-md duration-300 group ${tomo.highlight ? 'border-amber-300 bg-amber-50' : 'border-slate-200 bg-white shadow-sm'}`} data-id="element-68">
                <span className={`absolute top-3 right-3 text-[10px] md:text-xs font-black ${tomo.highlight ? 'text-amber-500' : 'text-slate-300'}`} data-id="element-69">
                  {tomo.num}
                </span>
                <div className={`w-11 h-11 md:w-12 md:h-12 rounded-xl flex items-center justify-center mb-3 transition-transform group-hover:scale-110 ${tomo.highlight ? 'bg-amber-400 text-slate-900' : 'bg-slate-900 text-teal-300'}`} data-id="element-70">
                  <Icon className="h-5 w-5 md:h-6 md:w-6" aria-hidden="true" data-id="element-71" />
                </div>
                <h4 className="font-bold text-sm md:text-base text-slate-900 leading-tight mb-0.5" data-id="element-72">
                  {tomo.title}
                </h4>
                <p className={`text-xs md:text-sm font-medium ${tomo.highlight ? 'text-amber-700' : 'text-teal-600'}`} data-id="element-73">
                  {tomo.subtitle}
                </p>
              </div>;
        })}
        </div>
      </div>
    </Section>;
}